import React, { useState } from 'react';
// import { postData } from '../../services/api.service';
import { swalAlertDanger, swalAlertSuccess } from '../common/Alerts';

const ImageUploader = ({ currentImageUrl, onImageUploaded }) => {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(currentImageUrl || null);

  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validar tipo de archivo
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
    if (!allowedTypes.includes(file.type)) {
      swalAlertDanger(
        'Tipo de archivo no permitido', 
        'Solo se permiten archivos JPG, JPEG, PNG y GIF',
        () => {}
      );
      return;
    }

    // Validar tamaño (5MB)
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      swalAlertDanger(
        'Archivo demasiado grande', 
        'El archivo no puede superar los 5MB',
        () => {}
      );
      return;
    }

    // Crear preview
    const reader = new FileReader();
    reader.onload = (e) => setPreview(e.target.result);
    reader.readAsDataURL(file);

    // Subir archivo
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('image', file);

      const uploadUrl = `${process.env.REACT_APP_API_URL}/api/admin/upload_burger_image`;
      const response = await fetch(uploadUrl, {
        method: 'POST',
        body: formData,
      });


      const result = await response.json();

      if (result.success) {
        swalAlertSuccess('Imagen subida exitosamente', '', () => {});
        onImageUploaded(result.imageUrl);
      } else {
        swalAlertDanger('Error al subir imagen', result.msg, () => {});
        setPreview(currentImageUrl || null);
      }
    } catch (error) {
      console.error('Error detallado:', error);
      console.error('Error stack:', error.stack);
      swalAlertDanger('Error al subir imagen', `Error de conexión: ${error.message}`, () => {});
      setPreview(currentImageUrl || null);
    } finally {
      setUploading(false);
    }
  };

  const handleRemoveImage = () => {
    setPreview(null);
    onImageUploaded(null);
  };

  return (
    <div className="mb-3">
      <label className="form-label">Imagen de la hamburguesa</label>
      
      {preview && (
        <div className="mb-3">
          <img 
            src={preview} 
            alt="Preview" 
            className="img-thumbnail"
            style={{ maxHeight: '200px', maxWidth: '200px' }}
          />
          <div className="mt-2">
            <button 
              type="button" 
              className="btn btn-sm btn-danger"
              onClick={handleRemoveImage}
              disabled={uploading}
            >
              Eliminar imagen
            </button>
          </div>
        </div>
      )}

      <input
        type="file"
        className="form-control"
        accept="image/jpeg,image/jpg,image/png,image/gif"
        onChange={handleFileSelect}
        disabled={uploading}
      />
      
      {uploading && (
        <div className="mt-2">
          <div className="spinner-border spinner-border-sm" role="status">
            <span className="visually-hidden">Subiendo...</span>
          </div>
          <span className="ms-2">Subiendo imagen...</span>
        </div>
      )}
      
      <div className="form-text">
        Formatos permitidos: JPG, JPEG, PNG, GIF. Tamaño máximo: 5MB
      </div>
    </div>
  );
};

export default ImageUploader;
